import React, { useEffect, useState } from "react";
import FILTVChannelCard from "./FILTVChannelCard";

export default function FILTVChannelSheet({ open, channels, activeLcn, onSelect, onClose }) {
    const [show, setShow] = useState(false);

    useEffect(() => {
        if (open) {
            const id = requestAnimationFrame(() => setShow(true));
            return () => cancelAnimationFrame(id);
        }
        setShow(false);
    }, [open]);

    if (!open) return null;

    return (
        <div className="fixed inset-0 z-50 flex items-end lg:items-center lg:justify-center">
            <div
                className={`absolute inset-0 bg-black/70 backdrop-blur-sm transition-opacity duration-300 ${
                    show ? "opacity-100" : "opacity-0"
                }`}
                onClick={onClose}
            />

            <div
                className={`relative w-full lg:w-[440px] bg-zinc-950 border-t lg:border border-zinc-700 rounded-t-2xl lg:rounded-2xl p-4 max-h-[75vh] overflow-y-auto scrollbar-hide transition-transform duration-300 ${
                    show ? "translate-y-0 opacity-100" : "translate-y-full lg:translate-y-3 lg:opacity-0"
                }`}
            >
                <div className="flex items-center justify-between mb-3">
                    <h2 className="font-bold text-lg">📺 All Channels</h2>
                    <button
                        onClick={onClose}
                        className="text-zinc-400 hover:text-white text-xl leading-none px-2"
                        aria-label="Close"
                    >
                        ✕
                    </button>
                </div>

                <div className="grid grid-cols-3 gap-2">
                    {channels.map((channel) => (
                        <FILTVChannelCard
                            key={channel.lcn}
                            channel={channel}
                            active={channel.lcn === activeLcn}
                            onClick={() => onSelect(channel)}
                        />
                    ))}
                </div>
            </div>
        </div>
    );
}
